export const CREATE_SESSION = 'CREATE_SESSION';
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FETCH_USER = 'FETCH_USER';
export const WHO_AM_I = 'WHO_AM_I';
export const MIGRATION_STATUS = 'MIGRATION_STATUS';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';